import Api from './Api';
import Server from './index';
import Constants from '../../submodules/logictry_config/constants';

class LogicBaseLiveStreamApi extends Api {
  url = 'live-streams';

  getForContent(contentId, query) {
    return this.get(contentId, query);
  }

  updateCrew(contentId, body) {
    return Server.__patchRequest(`/${this.url}/${contentId}`, body);
  }

  devCreate(body) {
    return this.create(body);
  }

  meetingStart(contentId) {
    return Server.__postRequest(`/${this.url}/${contentId}/meeting/start`, {});
  }

  broadcastStart(contentId) {
    return Server.__postRequest(`/${this.url}/${contentId}/broadcast/start`, {});
  }

  broadcastEnd(contentId) {
    return Server.__postRequest(`/${this.url}/${contentId}/broadcast/end`, {});
  }

  createAttendee(contentId) {
    return Server.__postRequest(`/${this.url}/${contentId}/attendee`, {});
  }

  /** Panel presenter screen-share publisher token (web only). */
  createScreenShareAttendee(contentId) {
    return Server.__postRequest(`/${this.url}/${contentId}/attendee/screen-share`, {});
  }

  /** Remove the caller's own stage participant (Leave button / SPA navigate-away). */
  leave(contentId) {
    return Server.__postRequest(`/${this.url}/${contentId}/attendee/leave`, {});
  }

  /** RTMP host ingest credentials (never exposed publicly). */
  getBroadcastIngest(contentId) {
    return Server.__getRequest(`/${this.url}/${contentId}/broadcast/ingest`);
  }

  /** YouTube Live status (Data API via server). Viewers get `{ status, actualStartTime }`. */
  getYoutubeStatus(contentId, query) {
    return this.get(`${contentId}/youtube/status`, query);
  }

  /** Host moderation relay — server emits `livestream-camctrl` over the content websocket. */
  sendCamControl(contentId, payload) {
    return Server.__postRequest(`/${this.url}/${contentId}/cam-control`, payload);
  }

  /**
   * Unload-safe leave for page refresh / pull-to-refresh / tab close. A normal
   * XHR is cancelled when the document is torn down, so use a `keepalive` fetch
   * (which the browser is allowed to complete after unload) with the CSRF header
   * read from the page meta tag. Best-effort and fire-and-forget.
   */
  leaveBeacon(contentId) {
    if (!contentId || typeof fetch !== 'function') return;
    try {
      const headers = { 'content-type': 'application/json' };
      const csrf = typeof document !== 'undefined'
        && document.querySelector('meta[name="csrf-token"]');
      if (csrf && csrf.content) headers['csrf-token'] = csrf.content;
      fetch(`${Constants.logictryOrigin}/v1/${this.url}/${contentId}/attendee/leave`, {
        method: 'POST',
        headers,
        body: '{}',
        credentials: 'include',
        keepalive: true,
      }).catch(() => {});
    } catch {
      //
    }
  }
}

const singleton = new LogicBaseLiveStreamApi();
export default singleton;
